export interface Lead {
	id: string;
	employeeId: string;
	employeeName: string | null;
	formId: string;
	formName: string;
	formVersionId: string;
	formVersion: number;
	occurredAt: string;
	recordedAt: string;
	lat: number | null;
	lon: number | null;
	resolvedZoneId: string | null;
	resolvedLabel: string;
	address: string | null;
	taskId: string | null;
	taskName: string | null;
	suspicionFlags: string[];
}

/** Tafsilot — ro'yxat qatori + javoblar va PINLANGAN forma sxemasi. */
export interface LeadDetail extends Lead {
	answers: Record<string, unknown>;
	formSchema: { fields: LeadFormFieldView[] };
}

/**
 * `packages/domain` dagi `FormField` ning UI ga kerakli QISMI. To'liq
 * tipni import qilish `@domain/form` ga bog'lanish demak — u ham
 * mumkin, lekin bu yerda faqat ko'rsatish uchun kerakli maydonlar
 * yetarli va F1 sxemaga maydon qo'shganda bu fayl o'zgarmaydi.
 */
export interface LeadFormFieldView {
	key: string;
	type: string;
	label: string;
}

/** Shubha bayrog'ining o'zbekcha nomi — ro'yxat va tafsilotda bir xil. */
export const SUSPICION_LABELS: Record<string, string> = {
	// biome-ignore lint/style/useNamingConvention: kalit DB enum qiymati
	mock_provider: "Soxta joylashuv",
	speed: "Haddan tez harakat",
	teleport: "Teleport",
	// biome-ignore lint/style/useNamingConvention: kalit DB enum qiymati
	time_skew: "Qurilma soati noto'g'ri",
	// biome-ignore lint/style/useNamingConvention: kalit DB enum qiymati
	accuracy_anomaly: "Aniqlik past",
	jailbreak: "Jailbreak",
	// biome-ignore lint/style/useNamingConvention: kalit DB enum qiymati
	ip_mismatch: "IP mos emas",
};

export interface LeadMapPoint {
	id: string;
	employeeId: string;
	lat: number;
	lon: number;
	occurredAt: string;
	resolvedLabel: string;
	suspicionFlags: string[];
}

export interface LeadExportJob {
	id: string;
	status: "pending" | "processing" | "done" | "failed";
	rowCount: number | null;
	error: string | null;
	fileId: string | null;
	downloadUrl: string | null;
	createdAt: string;
	startedAt: string | null;
	finishedAt: string | null;
}
